import { RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';
import { TaskStatus } from '@models/tasks/task-status';

export class TaskActionStatus extends BaseTaskAction {
    type: TaskActionType.Status = TaskActionType.Status;
    state?: string;
    stateOld?: string;
    icon?: string;
    iconOld?: string;
    color?: string;
    colorOld?: string;
    title?: string;
    titleOld?: string;
    status?: TaskStatus;
    statusOld?: TaskStatus;

    constructor(json?: RecursivePartial<TaskActionStatus>) {
        super(json);
        this.parseTaskActionStatus(json || {});
    }

    parse(json: RecursivePartial<TaskActionStatus>): TaskActionStatus {
        super.parse(json);
        this.parseTaskActionStatus(json);
        return this;
    }

    private parseTaskActionStatus(json: RecursivePartial<TaskActionStatus>): void {
        TaskActionStatus.assignFields<TaskActionStatus>(this, json, [
            'state', 'stateOld',
            'icon', 'iconOld',
            'color', 'colorOld',
            'title', 'titleOld',
            'status', 'statusOld'
        ]);
    }
}
